import { cookie } from "src/utils/Cookie";
import { Cookie } from "src/constants/Cookie";

export const apiPostRequest = async (url: string, body: Record<string, any> = {}): Promise<Response> => {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": cookie.get(Cookie.TOKEN)
        },
        body: JSON.stringify(body)
    });
    if (response.status === 401) {
        cookie.remove(Cookie.TOKEN);
        alert("Your session has expired. Please refresh the page to continue.");
    }
    return response;
}
